import { render, staticRenderFns } from "./reject-reason.vue?vue&type=template&id=4e560f9f"
import script from "./reject-reason.vue?vue&type=script&lang=js"
export * from "./reject-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports